<template>
  <div>
    <PFRow :full-width="!form_in_line" :half-width="form_in_line" :separator="form_in_line" :label-class="form_in_line ? 'big':''" :label="$pgettext('priceList.linear.label','Complete set photo')">
      <PSelectKeyValue :options="setNums" :value="configuration.complete_set_num" @input="onSelectNum"/>
    </PFRow>
    <PFRow :full-width="!form_in_line" :half-width="form_in_line" :separator="form_in_line" :label-class="form_in_line ? 'big':''" :label="$pgettext('priceList.linear.label','Complete set price')">
      <PCurrencyInput v-model="configuration.complete_set_price" :currency="currency" @input="onUpdate"/>
    </PFRow>
  </div>
</template>

<script>

import PFRow from "@/domain/core/components/PFRow.vue";
import priceListRanges from "@/domain/core/constant/priceListRanges";
import PCurrencyInput from "@/domain/core/components/PCurrencyInput.vue";
import PSelectKeyValue from "@/domain/core/components/PSelectKeyValue.vue";
import {mapGetters} from "vuex";

export default {
  name: "PackPriceList",
  components: {PSelectKeyValue, PCurrencyInput, PFRow},
  emits: ['update'],
  props: {
    currency: {
      type: String,
      required: true
    },
    form_in_line: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      items: [],
      configuration: {
        complete_set_num: null,
        complete_set_price: null,
      }
    }
  },
  computed: {
    ...mapGetters('event', ['eventCurrency']),
    setNums() {
      const result = [];
      for (let i = 1; i <= 10; i++) {
        result.push({id: i, name: String(i)});
      }
      return result;
    }
  },
  methods: {
    onSelectNum(option) {
      this.configuration.complete_set_num = option ? option.value : null
      this.onUpdate()
    },
    init({items, configuration}) {
      this.items = items
      this.configuration = {
        ...this.configuration,
        complete_set_price: configuration.complete_set_price ?? null,
        complete_set_num: configuration.complete_set_num ?? null
      }
      if (this.configuration.complete_set_price !== null && this.items.length <= 0)
        this.onUpdate()
    },
    isValid() {
      return this.configuration.complete_set_num !== null && this.configuration.complete_set_price !== null && this.configuration.complete_set_price !== '' && parseFloat(this.configuration.complete_set_price) > 0
    },
    getPriceList() {
      return {
        items: this.items,
        configuration: this.configuration,
        settings: {
          allow_upsell: true,
          allow_preorder: false,
          cta_enabled: true,
          cta_min_qty: 0,
          cta_position: 'b'
        }
      }
    },
    generateRows() {
      if (!this.configuration.complete_set_price || !this.configuration.complete_set_num) return false
      this.items = []
      const multiplier = priceListRanges.find(multiplier => multiplier.length === parseInt(this.configuration.complete_set_num))
      if (!multiplier)
        return false
      this.items = multiplier.map((multy, index) => {
        let amount = this.configuration.complete_set_price * multy
        if (multy !== 1)
          amount = this.roundPrice(amount, this.configuration.complete_set_price)
        return {
          qty: index + 1,
          price: amount,
        }
      })
      return true
    },
    roundPrice(value, maxAmount) {
      // Step 1: Obtain the rounding factor
      // 24.5 -> 0.245 -> 1,
      // 245 -> 2.45 -> 1,
      // 2450 -> 24.5 -> 10
      const rounding = Math.pow(10, Math.floor(Math.log10(maxAmount / 100)))

      // Step 2: Divide the value by the rounding factor and round the result
      let roundedValue = Math.round(value / rounding)

      // Step 3: Multiply the result by rounding to get the rounded value
      return roundedValue * rounding
    },
    onUpdate() {
      if (!this.generateRows())
        return

      this.$emit('update', {
        items: this.items,
        configuration: this.configuration,
        settings: {
          allow_upsell: true,
          allow_preorder: false,
          cta_enabled: true,
          cta_min_qty: 0,
          cta_position: 'b'
        }
      })
    }
  }
}
</script>